<template>
  <div class="container mx-auto flex flex-col sm:px-12 laptop:px-24" :class="{
    'laptop:mt-100px pt-10 md:pt-16': !compact,
    'items-center': !!itemsCenter,
    'items-end': !!itemsEnd,
    'laptop:flex-row': !reverse,
    'laptop:flex-row-reverse': !!reverse,
  }">
    <!-- fullhd:pr-65px md:w-5/6 fullhd:pl-5 md:mx-8 -->
    <!-- 1/12 = 8.33 -->
    <div v-if="slots.col1"
      class="w-full laptop:w-11/24 p-5 sm:p-0" :class="{
      'laptop:mr-1/24': !reverse,
      'laptop:ml-1/24': !!reverse,
    }">
      <slot name="col1" />
      <!-- <p class="text-standard laptop:text-slg md:text-base leading-7"></p> -->
    </div>
    <!-- md:w-5/6 md:mx-8     md:mt-12-->
    <div v-if="slots.col2"
      class="w-full laptop:w-11/24 p-5 sm:p-0 mt-0 sm:mt-8 laptop:mt-0" :class="{
      'laptop:mr-1/24': !!reverse,
      'laptop:ml-1/24': !reverse,
    }">
      <!-- <p class="my-0 laptop:text-slg md:text-base leading-7" v-html='$t("home.sell-more-description-2")'></p> -->
      <slot name="col2" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const slots = useSlots()

const props = defineProps({
  compact: { type: Boolean, default: false },
  itemsCenter: { type: Boolean, default: false },
  itemsEnd: { type: Boolean, default: false },
  reverse: { type: Boolean, default: false },
})
</script>

<style scoped>

</style>
